module.exports = __webpack_public_path__ + "assets/img/model3.2485c931.png";